export default __webpack_public_path__ + "static/media/raze-val.52fa3b60.jfif";